var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-view"},_vm._l((_vm.items),function(item,index){return _c('a',{key:index,staticClass:"grid-item",style:({
        width: _vm.widthPercent,
		backgroundColor: _vm.selectedIndex === index ? item.bgColorSelected : item.bgColor,
		borderColor : _vm.selectedIndex === index ? item.borderColorSelect : item.borderColor,
		marginLeft : index % _vm.columns !== 0 ? _vm.gap : '0px'
      }),on:{"click":function($event){return _vm.$emit('itemClick', index)}}},[_c('div',{staticClass:"label",style:({
          color: _vm.selectedIndex === index ? item.textColorSelected : item.textColor
        })},[_vm._v(" "+_vm._s(item.title)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }